import { TradeInPreviewAcquisition } from '@carvana/merch-contracts';
import { isSuccess, Result } from '@carvana/merch-result';
import { httpWithAuth } from '~/clients';
import { MerchUiApiClientId } from '~/constants/common/ApiClientId';
import { getTradesV2 } from '~/constants/endpoints';
import { MerchUiTradeV2Response } from '~/pages/api/trades/v2/get';

export default async function fetchTradeInPreviewAcquisitions(
  correlationId: string
): Promise<TradeInPreviewAcquisition[]> {
  const url = getTradesV2({ currentPageUrl: window.location.href });

  const { data } = await httpWithAuth.get<Result<MerchUiTradeV2Response>>(url, {
    headers: {
      'x-client-id': MerchUiApiClientId,
      'x-correlation-id': correlationId
    }
  });

  return isSuccess(data) ? data.content.trades : [];
}
